export default [
  {
    position: "absolute",
    top: 20.5,
    left: 12,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "absenceCalendarP2.mTitleOne",
    mBody: "absenceCalendarP2.mBodyOne",
    isVideo: true,
    videoThumb: "SP-Absence-Thumb",
    videoURL: "SP-Absence.mp4",
    vidIcon: true,
    id: "SP_AbsenceRequest_Video_ApprovingRequests",
    index: 0,
  },
  {
    position: "absolute",
    top: 2.4,
    left: 83,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "absenceCalendarP2.mTitleTwo",
    mBody: "absenceCalendarP2.mBodyTwo",
    id: "SP_AbsenceRequest_Info_TeamView",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 0.5,
    left: 0.3,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 9,
    tooltipText: "absenceCalendarP2.ttTextOne",
    hover: false,
    tooltipClass: "right",
    id: "SP_AbsenceRequest_Navigation_Menu",
    index: 2,
  },
  {
    position: "absolute",
    top: 3.1,
    left: 13,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "absenceCalendarP2.ttTextTwo",
    hover: false,
    id: "SP_AbsenceRequest_Navigation_Communications",
    index: 3,
  },
  {
    position: "absolute",
    top: 3.1,
    left: 35.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "absenceCalendarP2.ttTextThree",
    hover: false,
    id: "SP_AbsenceRequest_Navigation_PayBenefits",
    index: 4,
  },
  {
    position: "absolute",
    top: 3.1,
    left: 50.4,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "absenceCalendarP2.ttTextFour",
    hover: false,
    id: "SP_AbsenceRequest_Navigation_Performance",
    index: 5,
  },
  {
    position: "absolute",
    top: 3.1,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 11,
    tooltipText: "absenceCalendarP2.ttTextFive",
    hover: false,
    id: "SP_AbsenceRequest_Navigation_Hiring",
    index: 6,
  },
  {
    position: "absolute",
    top: 2.4,
    left: 98.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "absenceCalendarP2.ttTextSix",
    hover: false,
    tooltipClass: "left",
    id: "SP_AbsenceRequest_Navigation_TeamMember",
    index: 7,
  },
  {
    position: "absolute",
    top: 20.5,
    left: 68.4,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "absenceCalendarP2.mobileAbsenceTitle",
    mBody: "absenceCalendarP2.mobileAbsenceBody",
    isVideo: true,
    videoThumb: "SP-Mobile-Absence-Thumb",
    videoURL: "SP-Mobile-Absence.mp4",
    vidIcon: true,
    id: "SP_AbsenceRequest_Mobile_Video_Absence",
    index: 8,
  },
];
